import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserDetailReducer, logoutReducer } from "../features/slice";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  //const [isMobile, setIsMobile] = useScreenWidth();

  //console.log(AdminDetail?.modules?.school);

  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 991;

  function handleShow() {
    setShow(!show);
  }

  const LogOut = useCallback(() => {
    dispatch(logoutReducer({}));
  }, [dispatch]);

  async function logout(e) {
    LogOut();
    await localStorage.removeItem("houzezToken");
    await localStorage.removeItem("houzezDetail");
    navigate("/");
  }

  const detail = useSelector((store) => store.main.userDetail);

  const getDetail = useCallback(() => {
    dispatch(UserDetailReducer({})).then((res) => {
      if (
        res?.payload?.message === "jwt malformed" ||
        res?.payload?.message === "invalid signature" ||
        res?.payload?.statusCode === 500
      ) {
        logout();
      }
    });
  }, [dispatch]);

  useEffect(() => {
    getDetail();
  }, [getDetail]);

  return (
    <div className="header-top-tab innerHeader navbar-expand-lg">
      <div className="toggleButton">
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => {
            handleShow();
          }}
        >
          <i className="fa fa-bars"></i>
        </button>
      </div>
      <div className="logoAbso">
        <img
          src="assets/images/logo.png"
          className="logo-icon"
          alt="Trifers"
          title="Trifers"
        />
      </div>
      <div
        className={
          !show ? "navbar-collapse collapse" : "navbar-collapse collapse show"
        }
      >
        <ul className="navbar-nav menurespo innerMenu ms-auto py-4 py-lg-0 align-items-center gg-10">
          <li className="navbar-items">
            <Link
              to="/plan"
              className={
                pathname.includes("plan")
                  ? "text-capitalize text-decoration-none link-img-text active"
                  : "text-capitalize text-decoration-none link-img-text"
              }
              onClick={() => {
                handleShow();
              }}
            >
              <img src="assets/images/Plan.png" alt="" className="menuImg" />
              plans
            </Link>
          </li>
          <li className="navbar-items">
            <Link
              to="/booking"
              className={
                pathname.includes("booking")
                  ? "text-capitalize text-decoration-none link-img-text active"
                  : "text-capitalize text-decoration-none link-img-text"
              }
              onClick={() => {
                handleShow();
              }}
            >
              <img
                src="assets/images/Mybooking.png"
                alt=""
                className="menuImg"
              />
              my booking
            </Link>
          </li>
          <li className="navbar-items">
            <Link
              to="/report"
              className={
                pathname.includes("report")
                  ? "text-capitalize text-decoration-none link-img-text active"
                  : "text-capitalize text-decoration-none link-img-text"
              }
              onClick={() => {
                handleShow();
              }}
            >
              <img src="assets/images/report.png" alt="" className="menuImg" />
              my reports
            </Link>
          </li>
        </ul>
      </div>
      <div className="noti-flex">
        <div className="profile-drop cursor-pointer position-relative">
          <div className="tabs-list">
            <span>
              <img
                src={
                  detail?.image?.includes("http")
                    ? detail?.image
                    : "assets/images/employe.png"
                }
                className="profile-img"
                alt=""
              />
            </span>
            <span>
              <h5 className="mb-0">{detail?.userName || "NA"}</h5>
            </span>
          </div>
          <div className="profile-collapse">
            <div className="noti-text">
              <Link
                to="/edit-profile"
                className={
                  pathname.includes("edit-profile") ? "theme-color" : ""
                }
              >
                Edit Profile
              </Link>
            </div>

            <div className="noti-text mt-2">
              <span
                className="cursor-pointer"
                onClick={() => {
                  logout();
                }}
              >
                Logout
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
